const text = {
  "af": {
      "help": "Ek het die goedere nie ontvang nie",
      "quotaLimit": "USPS-opsporing nie beskikbaar nie. Limiet bereik.",
      "uspsLimitedTips": "USPS-opsporing is beperk weens beleidsveranderinge. Gradeer op vir meer opsporingsversoeke.",
      "learnMore": "Leer Meer",
      "upgradePlan": "Upgrade Now",
      "helpDesc": "Ons is baie jammer. 17TRACK is 'n derdeparty wêreldwye logistieke inligtingsaggregasieplatform wat jou in staat stel om die logistieke status van verskeie pakkette gerieflik te raadpleeg. Vir leveringsprobleme met pakkette, kontak die logistieke onderneming of die handelaar.",
      "helpTitle": "Geagte gebruiker",
      "website": "Offisiële webwerf",
      "noWebsite": "Geen inligting oor die amptelike webwerf beskikbaar nie. Dit word aanbeveel om die verkoper te kontak.",
      "contact": "Logistiek kontakinfo",
      "userAgree": "Stem in tot die {0}",
      "userAgreeLink": "Diensbepalings",
      "uspsTrackingInstructions": "USPS-opsporingsinstruksies",
      "uspsInstructions1": "As gevolg van beleidsveranderinge deur USPS, gebruik USPS-tracking nou ’n toegewyde kwota. Betalende gebruikers kan USPS-spoorsnommers tot hul planlimiet per faktuursiklus byvoeg. Die kwota word outomaties herstel.",
      "uspsInstructions2": "As die beskikbare planne steeds nie aan jou USPS-trackingbehoeftes voldoen nie, kontak ons ondersteuningspan by "
  },
  "ar": {
      "help": "لم أتلقى البضاعة",
      "quotaLimit": "خدمة تتبع البريد الأمريكي غير متاحة. تم الوصول إلى الحد الأقصى.",
      "uspsLimitedTips": "تتبع USPS محدود بسبب تغييرات السياسة. قم بالترقية للحصول على المزيد من طلبات التتبع.",
      "learnMore": "يتعلم أكثر",
      "upgradePlan": "الترقية الآن",
      "helpDesc": "نأسف بغضب. 17TRACK منصة ثالثة لجمع معلومات اللوجستية العالمية، تتيح لك استعلام سهل عن حالة اللوجستية لأكثر من حزمة. ل문제 توصيل الحزم، يرجى الاتصال بالشركة اللوجستية أو التاجر.",
      "helpTitle": "ي المستخدم",
      "website": "الموقع الرسمي",
      "noWebsite": "لا توجد معلومات عن الموقع الرسمي متوفرة. يُنصح بمراسلة البائع.",
      "contact": "معلومات الاتصال باللوجستية",
      "userAgree": "الموافقة على {0}",
      "userAgreeLink": "شروط الخدمة",
      "uspsTrackingInstructions": "تعليمات تتبع USPS",
      "uspsInstructions1": "بسبب تغييرات سياسة USPS، يستخدم تتبع USPS الآن حصة مخصصة. يمكن للمستخدمين المدفوعين إضافة أرقام تتبع USPS وفقًا لحدود خطتهم لكل دورة فوترة. تتم إعادة تعيين الحصة تلقائيًا.",
      "uspsInstructions2": "إذا كانت الخطط المتاحة لا تزال لا تلبي احتياجات تتبع USPS الخاصة بك، فيرجى الاتصال بفريق الدعم لدينا على "
  },
  "az": {
      "help": "Mən malları almadım",
      "quotaLimit": "USPS izləmə mümkün deyil. Limitə çatdınız",
      "uspsLimitedTips": "USPS izləmə siyasət dəyişikliklərinə görə məhduddur. Daha çox izləmə sorğusu üçün yüksəldin.",
      "learnMore": "Daha çox məlumat əldə edin",
      "upgradePlan": "İndi yüksəlt",
      "helpDesc": "Çox üzr istəyirik. 17TRACK qlobal üçüncü tərəf lojistik məlumatlarını toplayan platformadır və sizə bir neçə paketin lojistik vəziyyətini asanlıqla yoxlamağa imkan verir. Paketlərin çatdırılma problemləri üçün lojistik şirkəti və ya satıcı ilə əlaqə qurun.",
      "helpTitle": "Hurmatlı istifadəçi",
      "website": "Rəsmi veb sayt",
      "noWebsite": "Rəsmi veb sayt haqqında məlumat yoxdur. Satıcı ilə əlaqə qurmaq tövsiyə olunur.",
      "contact": "Lojistik kontakt məlumatı",
      "userAgree": "{0} razıyam",
      "userAgreeLink": "Xidmət şərtləri",
      "uspsTrackingInstructions": "USPS izləmə təlimatları",
      "uspsInstructions1": "USPS siyasətindəki dəyişikliklər səbəbindən USPS izləməsi artıq xüsusi kvotadan istifadə edir. Ödənişli istifadəçilər hesablaşma dövrü üzrə plan limitinə qədər USPS izləmə nömrələri əlavə edə bilərlər. Kvota avtomatik sıfırlanır.",
      "uspsInstructions2": "Mövcud planlar hələ də USPS izləmə ehtiyaclarınızı qarşılamırsa, dəstək komandamızla  ünvanından əlaqə saxlayın."
  },
  "bg": {
      "help": "Не получих стоките",
      "quotaLimit": "Проследяването на USPS не е налично. Достигнат е лимитът.",
      "uspsLimitedTips": "Проследяването на USPS е ограничено поради промени в политиката. Надстройте за повече заявки за проследяване.",
      "learnMore": "Научете повече",
      "upgradePlan": "Актуализирай сега",
      "helpDesc": "Много се съжаляваме. 17TRACK е трета страна глобална платформа за агрегация на логистични информация, която ви позволява лесно да проверявате логистическия статус на няколко пратки. При проблеми с доставката на пратките се свържете с логистическата фирма или търговеца.",
      "helpTitle": "Поважени потребител",
      "website": "Официален сайт",
      "noWebsite": "Няма налични информация за официалната уеб страница. Препоръчва се да се свържете с продавача.",
      "contact": "Контактна информация за логистиката",
      "userAgree": "Приемам {0}",
      "userAgreeLink": "Условия за ползване",
      "uspsTrackingInstructions": "Инструкции за проследяване на USPS",
      "uspsInstructions1": "Поради промени в политиката на USPS, проследяването на USPS вече използва специална квота. Платените потребители могат да добавят номера за проследяване на USPS до лимита на своя план за цикъл на фактуриране. Квотата се нулира автоматично.",
      "uspsInstructions2": "Ако наличните планове все още не отговарят на нуждите ви от проследяване на USPS, моля, свържете се с екипа ни за поддръжка на "
  },
  "cs": {
      "help": "Nedostal jsem zboží",
      "quotaLimit": "Sledování USPS není k dispozici. Dosažen limit.",
      "uspsLimitedTips": "Sledování USPS je omezeno kvůli změnám zásad. Upgradujte pro více požadavků na sledování.",
      "learnMore": "Zjistěte více",
      "upgradePlan": "Upgradovat nyní",
      "helpDesc": "Velmi se omlouváme. 17TRACK je třetí strana globální platforma pro agregaci logistických informací, která vám umožňuje pohodlně zjistit logistický stav několika balíků. Při problémech s dodacími službami balíků kontaktujte prosím logistickou společnost nebo obchodníka.",
      "helpTitle": "Vážení uživateli",
      "website": "Oficiální webová stránka",
      "noWebsite": "Žádné informace o oficiální webové stránce nejsou k dispozici. Doporučuje se kontaktovat prodejce.",
      "contact": "Logistická kontaktní info",
      "userAgree": "Souhlasit s {0}",
      "userAgreeLink": "Podmínky služby",
      "uspsTrackingInstructions": "Pokyny pro sledování USPS",
      "uspsInstructions1": "Kvůli změnám pravidel USPS nyní sledování USPS využívá vyhrazenou kvótu. Platící uživatelé mohou přidávat sledovací čísla USPS až do limitu svého plánu za fakturační cyklus. Kvóta se automaticky resetuje.",
      "uspsInstructions2": "Pokud dostupné plány stále nevyhovují vašim potřebám sledování USPS, kontaktujte náš tým podpory na adrese "
  },
  "da": {
      "help": "Jeg har ikke modtaget varerne",
      "quotaLimit": "USPS-sporing ikke tilgængelig. Grænsen er nået.",
      "uspsLimitedTips": "USPS-sporing er begrænset på grund af politikændringer. Opgrader for flere sporingsforespørgsler.",
      "learnMore": "Lær mere",
      "upgradePlan": "Opgrader nu",
      "helpDesc": "Vi er utrolig undskyldne. 17TRACK er en tredjepartsplatform for global aggregation af logistisk information, der lader dig nemt kontrollere logistikstatusen for flere pakker. Ved leveringsproblemer med pakker skal du kontakte logistikselskabet eller forhandleren.",
      "helpTitle": "Dear user",
      "website": "Officiel website",
      "noWebsite": "Ingen information om den officielle hjemmeside tilgængelig. Anbefales at kontakte sælgeren.",
      "contact": "Logistik kontaktinfo",
      "userAgree": "Accepter {0}",
      "userAgreeLink": "Vilkår for brug",
      "uspsTrackingInstructions": "USPS-sporingsinstruktioner",
      "uspsInstructions1": "På grund af politikændringer hos USPS bruger USPS-sporing nu en dedikeret kvote. Betalende brugere kan tilføje USPS-sporingsnumre op til deres plangrænse pr. faktureringscyklus. Kvoten nulstilles automatisk.",
      "uspsInstructions2": "Hvis de tilgængelige planer stadig ikke opfylder dine USPS-sporingsbehov, bedes du kontakte vores supportteam på "
  },
  "de": {
      "help": "Ich habe die Ware nicht erhalten",
      "quotaLimit": "USPS-Sendungsverfolgung nicht verfügbar. Limit erreicht.",
      "uspsLimitedTips": "USPS-Sendungsverfolgung ist aufgrund von Richtlinienänderungen eingeschränkt. Upgraden Sie für mehr Tracking-Anfragen.",
      "learnMore": "Mehr erfahren",
      "upgradePlan": "Jetzt upgraden",
      "helpDesc": "Wir entschuldigen uns zutiefst. 17TRACK ist eine drittanbieterische globale Logistikinformationsaggregationsplattform, mit der Sie den Logistikstatus mehrerer Pakete bequem abfragen können. Bei Paketzustellproblemen wenden Sie sich bitte an das Logistikunternehmen oder den Händler.",
      "helpTitle": "r geehrter Benutzer",
      "website": "Offizielle Website",
      "noWebsite": "Keine Informationen zur offiziellen Website verfügbar. Es wird empfohlen, sich an den Verkäufer zu wenden.",
      "contact": "Logistik-Kontaktinfo",
      "userAgree": "{0} zustimmen",
      "userAgreeLink": "Nutzungsbedingungen",
      "uspsTrackingInstructions": "USPS-Sendungsverfolgungsanleitung",
      "uspsInstructions1": "Aufgrund von Richtlinienänderungen der USPS verwendet die USPS-Sendungsverfolgung jetzt ein dediziertes Kontingent. Zahlende Nutzer können pro Abrechnungszeitraum USPS-Sendungsnummern bis zu ihrem Planlimit hinzufügen. Das Kontingent wird automatisch zurückgesetzt.",
      "uspsInstructions2": "Sollten die verfügbaren Tarife Ihren USPS-Tracking-Bedarf weiterhin nicht decken, kontaktieren Sie bitte unser Support-Team unter "
  },
  "el": {
      "help": "Δεν έλαβα τα προϊόντα",
      "quotaLimit": "Η παρακολούθηση USPS δεν είναι διαθέσιμη. Συμπληρώθηκε το όριο.",
      "uspsLimitedTips": "Η παρακολούθηση USPS είναι περιορισμένη λόγω αλλαγών πολιτικής. Αναβαθμίστε για περισσότερα αιτήματα παρακολούθησης.",
      "learnMore": "Μάθετε περισσότερα",
      "upgradePlan": "Αναβάθμιση τώρα",
      "helpDesc": "Σας ζητάμε συγνώμη πάρα πολύ. 17TRACK είναι μια πλατφόρμα τρίτου μέρους για συλλογή παγκόσμιων πληροφοριών λογιστικής, която σας επιτρέπει να ελέγξετε εύκολα την λογιστική κατάσταση πολλών πακέτων. Για προβλήματα παράδοσης πακέτων, επικοινωνήστε με την εταιρεία λογιστικής ή τον εμπόρο.",
      "helpTitle": "Αγαπητέ χρήστη",
      "website": "Επίσημοι ιστότοποι",
      "noWebsite": "Δεν υπάρχουν διαθέσιμες πληροφορίες για τον επίσημο ιστότοπο. Συνιστάται να επικοινωνήσετε με τον πωλητή.",
      "contact": "Λογιστική πληροφορίες επικοινωνίας",
      "userAgree": "Αποδοχή των {0}",
      "userAgreeLink": "Όροι χρήσης",
      "uspsTrackingInstructions": "Οδηγίες παρακολούθησης USPS",
      "uspsInstructions1": "Λόγω αλλαγών πολιτικής της USPS, η παρακολούθηση USPS χρησιμοποιεί πλέον ειδική ποσόστωση. Οι χρήστες που πληρώνουν μπορούν να προσθέτουν αριθμούς παρακολούθησης USPS εντός του ορίου του προγράμματός τους ανά κύκλο χρέωσης. Η ποσόστωση επαναφέρεται αυτόματα.",
      "uspsInstructions2": "Εάν τα διαθέσιμα προγράμματα εξακολουθούν να μην καλύπτουν τις ανάγκες σας για παρακολούθηση USPS, επικοινωνήστε με την ομάδα υποστήριξής μας στο "
  },
  "en": {
      "help": "I have not received the goods",
      "quotaLimit": "USPS tracking unavailable. Limit reached",
      "uspsLimitedTips": "USPS tracking is limited due to policy changes. Upgrade for more tracking requests.",
      "learnMore": "Learn More",
      "upgradePlan": "Upgrade Now",
      "helpDesc": "We are extremely sorry. 17TRACK is a third-party global logistics information aggregation platform that enables you to conveniently check the logistics status of multiple parcels. For parcel delivery issues, please contact the logistics company or the merchant.",
      "helpTitle": "Dear user",
      "website": "Official website",
      "noWebsite": "No official website information available. It is recommended to contact the seller.",
      "contact": "Logistics contact info",
      "userAgree": "Agree to the {0}",
      "userAgreeLink": "Terms of Service",
      "uspsTrackingInstructions": "USPS Tracking Instructions",
      "uspsInstructions1": "Due to USPS policy changes, USPS tracking now uses a dedicated quota. Paid users can add USPS tracking numbers up to their plan limit per billing cycle (auto-reset).",
      "uspsInstructions2": "If the available plans still do not meet your USPS tracking needs, please contact our support team at "
  },
  "es": {
      "help": "No he recibido la mercancía",
      "quotaLimit": "Seguimiento de USPS no disponible. Límite alcanzado.",
      "uspsLimitedTips": "El seguimiento de USPS está limitado debido a cambios de política. Actualiza para obtener más solicitudes de seguimiento.",
      "learnMore": "Más información",
      "upgradePlan": "Actualizar ahora",
      "helpDesc": "Lamentamos profundamente. 17TRACK es una plataforma de agregación de información logística global de terceros que le permite consultar convenientemente el estado logístico de múltiples paquetes. Para problemas de entrega de paquetes, contáctese con la empresa logística o el comerciante.",
      "helpTitle": "Dear user",
      "website": "Sitio web oficial",
      "noWebsite": "No hay información de sitio web oficial disponible. Se recomienda contactar al vendedor.",
      "contact": "Info de contacto de logística",
      "userAgree": "Aceptar los {0}",
      "userAgreeLink": "Términos de servicio",
      "uspsTrackingInstructions": "Instrucciones de seguimiento de USPS",
      "uspsInstructions1": "Debido a cambios en las políticas de USPS, el seguimiento de USPS ahora utiliza una cuota dedicada. Los usuarios de pago pueden agregar números de seguimiento de USPS hasta el límite de su plan por ciclo de facturación. La cuota se restablece automáticamente.",
      "uspsInstructions2": "Si los planes disponibles aún no satisfacen sus necesidades de seguimiento de USPS, comuníquese con nuestro equipo de soporte en "
  },
  "fi": {
      "help": "En ole saanut tavaroita",
      "quotaLimit": "USPS-seuranta ei ole käytettävissä. Raja saavutettu.",
      "uspsLimitedTips": "USPS-seuranta on rajoitettu käytäntömuutosten vuoksi. Päivitä saadaksesi lisää seurantapyyntöjä.",
      "learnMore": "Lue lisää",
      "upgradePlan": "Päivitä nyt",
      "helpDesc": "Olemme erittäin pahoillamme. 17TRACK on maailmanlaajuinen kolmannen osapuolen logistisen tietojen yhdistämisplattformi, joka mahdollistaa useiden pakettien logistisen tilanteen helpon tarkistamisen. Pakettitoimitusongelmissa ota yhteyttä logistiseen yritykseen tai kauppiaan.",
      "helpTitle": "Arvoisa käyttäjä",
      "website": "Virallinen verkkosivu",
      "noWebsite": "Virallisen verkkosivun tietoja ei ole saatavilla. Suositellaan ottamaan yhteyttä myyjään.",
      "contact": "Logistikan kontaktiinfo",
      "userAgree": "Hyväksy {0}",
      "userAgreeLink": "Käyttöehdot",
      "uspsTrackingInstructions": "USPS-seurantaohjeet",
      "uspsInstructions1": "USPS:n käytäntömuutosten vuoksi USPS-seuranta käyttää nyt erillistä kiintiötä. Maksavat käyttäjät voivat lisätä USPS-seurantanumeroita laskutusjakson aikana pakettinsa rajoihin asti. Kiintiö nollautuu automaattisesti.",
      "uspsInstructions2": "Jos saatavilla olevat paketit eivät vieläkään täytä USPS-seurantatarpeitasi, ota yhteyttä tukeemme osoitteeseen ."
  },
  "fil": {
      "help": "Hindi ko natanggap ang mga paninda",
      "quotaLimit": "Hindi magagamit ang pagsubaybay sa USPS. Naabot na ang limitasyon.",
      "uspsLimitedTips": "Limitado ang USPS tracking dahil sa pagbabago ng patakaran. Mag-upgrade para sa mas maraming tracking requests.",
      "learnMore": "Matuto Nang Higit Pa",
      "upgradePlan": "Mag-upgrade ngayon",
      "helpDesc": "Lubos kaming humihingi ng paumanhin. 17TRACK ay isang third-party na pandaigdigang plataporma ng pagsasama-sama ng impormasyon sa logistika, na nagbibigay-daan sa iyo na madaling suriin ang estado ng logistika ng maraming pakete. Para sa mga problema sa paghahatid ng pakete, makipag-ugnayan sa kumpanyang logistika o sa mangangalakal.",
      "helpTitle": "Dear user",
      "website": "Opisyal na website",
      "noWebsite": "Walang available na impormasyon sa opisyal na website. Inirerekomenda na makipag-ugnayan sa nagbebenta.",
      "contact": "Info ng kontakto ng logistika",
      "userAgree": "Sumang-ayon sa {0}",
      "userAgreeLink": "Mga Tuntunin ng Serbisyo",
      "uspsTrackingInstructions": "Mga tagubilin sa pagsubaybay ng USPS",
      "uspsInstructions1": "Dahil sa mga pagbabago sa patakaran ng USPS, ang pagsubaybay sa USPS ay gumagamit na ngayon ng nakalaang quota. Maaaring magdagdag ang mga bayad na user ng mga numero ng pagsubaybay ng USPS hanggang sa limitasyon ng kanilang plano bawat cycle ng pagsingil. Awtomatikong nire-reset ang quota.",
      "uspsInstructions2": "Kung hindi pa rin natutugunan ng mga available na plano ang iyong mga pangangailangan sa pagsubaybay sa USPS, mangyaring makipag-ugnayan sa aming support team sa "
  },
  "fr": {
      "help": "Je n'ai pas reçu la marchandise",
      "quotaLimit": "Suivi USPS indisponible. Limite atteinte.",
      "uspsLimitedTips": "Le suivi USPS est limité en raison de changements de politique. Passez à un niveau supérieur pour plus de demandes de suivi.",
      "learnMore": "Apprendre encore plus",
      "upgradePlan": "Mettre à niveau",
      "helpDesc": "Nous sommes extrêmement désolés. 17TRACK est une plateforme tierce d'agrégation d'informations logistiques globales, qui vous permet de consulter facilement l'état logistique de plusieurs colis. Pour les problèmes de livraison des colis, veuillez contacter la société logistique ou le commerçant.",
      "helpTitle": "Cher utilisateur",
      "website": "Site officiel",
      "noWebsite": "Aucune information sur le site officiel disponible. Il est recommandé de contacter le vendeur.",
      "contact": "Info de contact de logistique",
      "userAgree": "Accepter les {0}",
      "userAgreeLink": "Conditions d'utilisation",
      "uspsTrackingInstructions": "Instructions de suivi USPS",
      "uspsInstructions1": "En raison des changements de politique d’USPS, le suivi USPS utilise désormais un quota dédié. Les utilisateurs payants peuvent ajouter des numéros de suivi USPS dans la limite de leur forfait par cycle de facturation. Le quota est automatiquement réinitialisé.",
      "uspsInstructions2": "Si les forfaits disponibles ne répondent toujours pas à vos besoins de suivi USPS, veuillez contacter notre équipe d’assistance à "
  },
  "he": {
      "help": "לא קיבלתי את המוצרים",
      "quotaLimit": "מעקב USPS אינו זמין. הגעת למגבלה.",
      "uspsLimitedTips": "מעקב USPS מוגבל עקב שינויי מדיניות. שדרג לקבלת יותר בקשות מעקב.",
      "learnMore": "למידע נוסף",
      "upgradePlan": "שדרג עכשיו",
      "helpDesc": "אנחנו מתנצלים מאוד. 17TRACK היא פלטפורמה של צד שלישי לקובץ מידע לוגיסטי גלובלי, המאפשרת לך לבדוק בקלות את מצב הלוגיסטיקה של מספר חבילות. לבעיות אספקה של חבילות, אנא צור קשר עם חברת הלוגיסטיקה או הסוחר.",
      "helpTitle": "יקירי משתמש",
      "website": "אתר רשמי",
      "noWebsite": "אין מידע על האתר הרשמי זמין. מומלץ לפנות לממוכר.",
      "contact": "מידע יצירת קשר ללוגיסטיקה",
      "userAgree": "מסכים ל-{0}",
      "userAgreeLink": "תנאי השירות",
      "uspsTrackingInstructions": "הוראות מעקב USPS",
      "uspsInstructions1": "עקב שינויים במדיניות USPS, מעקב USPS משתמש כעת במכסה ייעודית. משתמשים בתשלום יכולים להוסיף מספרי מעקב של USPS עד למגבלת התוכנית שלהם לכל מחזור חיוב. המכסה מתאפסת אוטומטית.",
      "uspsInstructions2": "אם התוכניות הזמינות עדיין אינן עונות על צרכי מעקב USPS שלך, אנא צור קשר עם צוות התמיכה שלנו בכתובת "
  },
  "hi": {
      "help": "मुझे माल नहीं मिला",
      "quotaLimit": "यूएसपीएस ट्रैकिंग अनुपलब्ध है। सीमा पूरी हो गई है।",
      "uspsLimitedTips": "नीति परिवर्तन के कारण USPS ट्रैकिंग सीमित है। अधिक ट्रैकिंग अनुरोधों के लिए अपग्रेड करें।",
      "learnMore": "और अधिक जानें",
      "upgradePlan": "अभी अपग्रेड करें",
      "helpDesc": "हम बहुत खेदित हैं। 17TRACK एक वैश्विक लॉजिस्टिक्स सूचना तृतीय पक्ष एकत्रीकरण प्लेटफॉर्म है, जो आपको कई पार्सल के लॉजिस्टिक्स स्टेटस को आसानी से जांचने की अनुमति देता है। पार्सल की डिलीवरी की समस्याओं के लिए, कृपया लॉजिस्टिक्स कंपनी या व्यापारी से संपर्क करें।",
      "helpTitle": "प्रिय उपयोगकर्ता",
      "website": "आधिकारिक वेबसाइट",
      "noWebsite": "कोई आधिकारिक वेबसाइट की जानकारी उपलब्ध नहीं है। विक्रेता से संपर्क करने की सलाह दी जाती है।",
      "contact": "लॉजिस्टिक कंपनी संपर्क जानकारी",
      "userAgree": "{0} से सहमत",
      "userAgreeLink": "सेवा की शर्तें",
      "uspsTrackingInstructions": "USPS ट्रैकिंग निर्देश",
      "uspsInstructions1": "USPS नीति परिवर्तनों के कारण, USPS ट्रैकिंग अब एक समर्पित कोटा का उपयोग करती है। सशुल्क उपयोगकर्ता प्रति बिलिंग चक्र अपनी योजना सीमा तक USPS ट्रैकिंग नंबर जोड़ सकते हैं। कोटा स्वचालित रूप से रीसेट हो जाता है।",
      "uspsInstructions2": "यदि उपलब्ध योजनाएँ अभी भी आपकी USPS ट्रैकिंग आवश्यकताओं को पूरा नहीं करती हैं, तो कृपया हमारी सहायता टीम से  पर संपर्क करें।"
  },
  "hu": {
      "help": "Nem kaptam meg a terméket",
      "quotaLimit": "USPS követés nem elérhető. Elérte a limitet.",
      "uspsLimitedTips": "A USPS követés korlátozott a szabályzatváltozások miatt. Frissítsen több követési kérelemért.",
      "learnMore": "Tudj meg többet",
      "upgradePlan": "Frissítés most",
      "helpDesc": "Nagyon sajnáljuk. 17TRACK egy harmadik fél által működtetett globális logisztikai információ-aggregációs platform, amely lehetővé teszi, hogy könnyen ellenőrizd több csomag logisztikai állapotát. Csomagszállítási problémák esetén lépj kapcsolatba a logisztikai céggel vagy a kereskedővel.",
      "helpTitle": "Kedves felhasználó",
      "website": "Hivatalos weboldal",
      "noWebsite": "Nincsenek elérhető információk az hivatalos weboldalról. Ajánlott a eladót felvenni.",
      "contact": "Logisztikai kapcsolati info",
      "userAgree": "Elfogadom a(z) {0}",
      "userAgreeLink": "Szolgáltatási feltételek",
      "uspsTrackingInstructions": "USPS követési útmutató",
      "uspsInstructions1": "Az USPS irányelvváltozásai miatt az USPS-követés mostantól dedikált kvótát használ. A fizetős felhasználók számlázási ciklusonként a csomagjuk keretéig adhatnak hozzá USPS-követési számokat. A kvóta automatikusan visszaáll.",
      "uspsInstructions2": "Ha a rendelkezésre álló csomagok továbbra sem felelnek meg az USPS-követési igényeinek, vegye fel a kapcsolatot támogatási csapatunkkal a  címen."
  },
  "id": {
      "help": "Saya belum menerima barang",
      "quotaLimit": "Pelacakan USPS tidak tersedia. Batas telah tercapai.",
      "uspsLimitedTips": "Pelacakan USPS dibatasi karena perubahan kebijakan. Upgrade untuk lebih banyak permintaan pelacakan.",
      "learnMore": "Pelajari Selengkapnya",
      "upgradePlan": "Upgrade sekarang",
      "helpDesc": "Kami sangat menyesal. 17TRACK adalah platform agregasi informasi logistik global pihak ketiga yang memungkinkan Anda dengan mudah memeriksa status logistik beberapa paket. Untuk masalah pengiriman paket, silakan hubungi perusahaan logistik atau pedagang.",
      "helpTitle": "Yang terhormat pengguna",
      "website": "Situs resmi",
      "noWebsite": "Tidak ada informasi situs resmi yang tersedia. Disarankan untuk menghubungi penjual.",
      "contact": "Info kontak logistik",
      "userAgree": "Setuju dengan {0}",
      "userAgreeLink": "Ketentuan Layanan",
      "uspsTrackingInstructions": "Instruksi pelacakan USPS",
      "uspsInstructions1": "Karena perubahan kebijakan USPS, pelacakan USPS sekarang menggunakan kuota khusus. Pengguna berbayar dapat menambahkan nomor pelacakan USPS hingga batas paket mereka per siklus penagihan. Kuota diatur ulang secara otomatis.",
      "uspsInstructions2": "Jika paket yang tersedia masih belum memenuhi kebutuhan pelacakan USPS Anda, silakan hubungi tim dukungan kami di "
  },
  "is": {
      "help": "Ég hef ekki fengið vörurnar",
      "quotaLimit": "USPS rakning ekki í boði. Takmörkum náð.",
      "uspsLimitedTips": "USPS-rakning er takmörkuð vegna stefnubreytinga. Uppfærðu til að fá fleiri rakningarbeiðnir.",
      "learnMore": "Frekari upplýsingar",
      "upgradePlan": "Uppfæra núna",
      "helpDesc": "Við erum mjög leiðinleg. 17TRACK er þriðja aðila alþjóðlegur stjórnsýsla fyrir flutningsupplýsingar, sem gerir þér kleift að athuga auðveldlega flutningsstaðan hjá nokkrum pakkana. Við flutningsproblemem með pakkum, hafðu samband við flutningsfyrirtækið eða söluaðilinn.",
      "helpTitle": "Kære notandi",
      "website": "Opinber vefsíða",
      "noWebsite": "Engar upplýsingar um opinbera vefsíðuna tiltækar. Mælt er með að hafa samband við seljanda.",
      "contact": "Flutningskontaktinfo",
      "userAgree": "Samþykkja {0}",
      "userAgreeLink": "Skilmálar þjónustu",
      "uspsTrackingInstructions": "USPS rakningarleiðbeiningar",
      "uspsInstructions1": "Vegna breytinga á stefnu USPS, notar USPS-rakning nú sérstakt kvóta. Greiðandi notendur geta bætt við USPS-rakningarnúmerum allt að pláneturmörkum á hverjum reikningsferli. Kvótinn endurstillist sjálfkrafa.",
      "uspsInstructions2": "Ef tiltækar áætlanir uppfylla enn ekki USPS-rakningarfarir þínar, vinsamlegast hafðu samband við stuðningsteymið okkar á "
  },
  "it": {
      "help": "Non ho ricevuto la merce",
      "quotaLimit": "Tracciamento USPS non disponibile. Limite raggiunto.",
      "uspsLimitedTips": "Il tracciamento USPS è limitato a causa di modifiche alle politiche. Aggiorna per ottenere più richieste di tracciamento.",
      "learnMore": "Saperne di più",
      "upgradePlan": "Aggiorna ora",
      "helpDesc": "Ci dispiace moltissimo. 17TRACK è una piattaforma terza per l'aggregazione di informazioni logistiche globali, che consente di consultare comodamente lo stato logistico di più pacchetti. Per problemi di consegna dei pacchetti, contattare l'azienda logistica o il commerciante.",
      "helpTitle": "Dear user",
      "website": "Sito ufficiale",
      "noWebsite": "Nessuna informazione sul sito ufficiale disponibile. Si consiglia di contattare il venditore.",
      "contact": "Info di contatto della logistica",
      "userAgree": "Accetta i {0}",
      "userAgreeLink": "Termini di servizio",
      "uspsTrackingInstructions": "Istruzioni per il tracciamento USPS",
      "uspsInstructions1": "A causa delle modifiche alle policy di USPS, il tracking USPS utilizza ora una quota dedicata. Gli utenti paganti possono aggiungere numeri di tracking USPS entro il limite del proprio piano per ciclo di fatturazione. La quota viene azzerata automaticamente.",
      "uspsInstructions2": "Se i piani disponibili non soddisfano ancora le tue esigenze di tracciamento USPS, contatta il nostro team di supporto all’indirizzo "
  },
  "ja": {
      "help": "商品を受け取っていません",
      "quotaLimit": "USPSの追跡サービスは利用できません。上限に達しました。",
      "uspsLimitedTips": "ポリシー変更により、USPS追跡は制限されています。アップグレードして追跡リクエストを増やしましょう。",
      "learnMore": "もっと詳しく知る",
      "upgradePlan": "今すぐアップグレード",
      "helpDesc": "大変申し訳ございません。17TRACK はグローバルな物流情報サードパーティーアグリゲーションプラットフォームで、複数の荷物の物流状況を簡便に確認できます。荷物の配送に関する問題がある場合は、物流会社または事業者にお問い合わせください。",
      "helpTitle": "尊敬するユーザー様",
      "website": "公式サイト",
      "noWebsite": "公式サイトの情報は現在入手できません。売り手に連絡することを推奨します。",
      "contact": "物流会社連絡先",
      "userAgree": "{0}に同意する",
      "userAgreeLink": "利用規約",
      "uspsTrackingInstructions": "USPS追跡手順",
      "uspsInstructions1": "USPS のポリシー変更により、USPS トラッキングは専用枠制となりました。有料ユーザーは、請求サイクルごとにプランの上限まで USPS トラッキング番号を追加できます。枠は自動的にリセットされます。",
      "uspsInstructions2": "ご利用のプランで USPS トラッキングのニーズを満たせない場合は、サポートチーム（）までお問い合わせください。"
  },
  "kk": {
      "help": "Мен тауарды алмадым",
      "quotaLimit": "USPS бақылауы мүмкін емес. Шектеуге жеттіңіз",
      "uspsLimitedTips": "USPS бақылауы саясат өзгерістеріне байланысты шектелген. Көбірек бақылау сұрауы үшін жаңартыңыз.",
      "learnMore": "Көбірек білу үшін",
      "upgradePlan": "Қазір жаңарту",
      "helpDesc": "Біз өте келіңіздерді кешірмеймініз. 17TRACK дүниежүзілік логистикалық ақпараттарды топтау üçün үшінші тарапті платформа болып табылады, ол сізге бірнеше посылаларының логистикалық жағдайын оңай тексеруге мүмкіндік береді. Посылалarın доставка проблемалары үшін логистикалық компанияға немесе саудашына хабарласудыңızды сұраймыз.",
      "helpTitle": "Құрметті пайдаланушы",
      "website": "Официалды веб-сайт",
      "noWebsite": "Официалды веб-сайт туралы ақпарат жоқ. Сатушымен байланысуға кеңес берілді.",
      "contact": "Логистика контактті ақпараты",
      "userAgree": "{0} келісемін",
      "userAgreeLink": "Қызмет көрсету шарттары",
      "uspsTrackingInstructions": "USPS бақылау нұсқаулығы",
      "uspsInstructions1": "USPS саясатындағы өзгерістерге байланысты USPS бақылау қызметі енді арнайы квотаны пайдаланады. Төлеуші пайдаланушылар әрбір есеп айырысу кезеңінде өз жоспарының шегіне дейін USPS бақылау нөмірлерін қоса алады. Квота автоматты түрде қалпына келеді.",
      "uspsInstructions2": "Қолжетімді жоспарлар әлі де USPS бақылау қажеттіліктеріңізді қанағаттандырмаса,  мекенжайы бойынша қолдау тобымызға хабарласыңыз."
  },
  "ko": {
      "help": "상품을 받지 못했어요",
      "quotaLimit": "USPS 추적 서비스를 이용할 수 없습니다. 이용 한도에 도달했습니다.",
      "uspsLimitedTips": "정책 변경으로 인해 USPS 추적이 제한됩니다. 더 많은 추적 요청을 위해 업그레이드하세요.",
      "learnMore": "더 알아보기",
      "upgradePlan": "지금 업그레이드",
      "helpDesc": "대단히 죄송합니다. 17TRACK는 글로벌 물류 정보 제3자 집계 플랫폼으로, 여러 패키지의 물류 상태를 편리하게 조회할 수 있도록 해줍니다. 패키지 배송 문제는 물류 회사 또는 상점에 문의하세요.",
      "helpTitle": "존경하는 사용자님",
      "website": "공식 웹사이트",
      "noWebsite": "공식 웹사이트 정보가 없습니다. 판매자에게 문의하는 것이 좋습니다.",
      "contact": "물류사 연락처",
      "userAgree": "{0}에 동의",
      "userAgreeLink": "서비스 약관",
      "uspsTrackingInstructions": "USPS 추적 안내",
      "uspsInstructions1": "USPS 정책 변경으로 인해 USPS 추적은 전용 할당량을 사용합니다. 유료 사용자는 청구 주기별로 요금제 한도까지 USPS 추적 번호를 추가할 수 있으며, 할당량은 자동으로 초기화됩니다.",
      "uspsInstructions2": "사용 가능한 요금제로도 USPS 추적 요구 사항을 충족할 수 없는 경우 지원팀()으로 문의하시기 바랍니다."
  },
  "lt": {
      "help": "Aš nenusipirkau prekių",
      "quotaLimit": "USPS sekimas negalimas. Pasiekta riba.",
      "uspsLimitedTips": "USPS sekimas ribojamas dėl politikos pakeitimų. Atnaujinkite, kad gautumėte daugiau sekimo užklausų.",
      "learnMore": "Sužinokite daugiau",
      "upgradePlan": "Atnaujinti dabar",
      "helpDesc": "Mes labai atsiprašome. 17TRACK yra trečiosios šalies globalinė logistikos informacijos agregavimo platforma, leidžianti lengvai patikrinti kelių siuntų logistikos būseną. Siuntimo problemoms susisiekite su logistikos įmone arba prekybininku.",
      "helpTitle": "Gerbiamas vartotojas",
      "website": "Oficialus tinklalapis",
      "noWebsite": "Oficialaus tinklalapio informacijų nėra. Rekomenduojama susisiekti su pardavėju.",
      "contact": "Logistikos kontaktinė info",
      "userAgree": "Sutinku su {0}",
      "userAgreeLink": "Paslaugos teikimo sąlygos",
      "uspsTrackingInstructions": "USPS sekimo instrukcijos",
      "uspsInstructions1": "Dėl USPS politikos pakeitimų, USPS sekimas dabar naudoja skirtą kvotą. Mokantys vartotojai gali pridėti USPS sekimo numerius iki savo plano limito per atsiskaitymo ciklą. Kvota automatiškai atstatoma.",
      "uspsInstructions2": "Jei turimi planai vis dar neatitinka jūsų USPS stebėjimo poreikių, susisiekite su mūsų palaikymo komanda el. paštu "
  },
  "mk": {
      "help": "Не добив производот",
      "quotaLimit": "Следењето на USPS е недостапно. Ограничувањето е достигнато.",
      "uspsLimitedTips": "Следењето на USPS е ограничено поради промени во политиката. Надградете за повеќе барања за следење.",
      "learnMore": "Дознајте повеќе",
      "upgradePlan": "Надгради сега",
      "helpDesc": "Многу се извинуваме. 17TRACK е трета страна глобална платформа за агрегација на логистички информации, која ви овозможува лесно да проверувате логистичкиот статус на неколку пакети. За проблеми со испорачката на пакетите, контактирајте логистичката компанија или трговецот.",
      "helpTitle": "Доштен корисник",
      "website": "Официјален сајт",
      "noWebsite": "Нема информации за официјалната веб страница. Препорачливо е да се контактирате со продавачот.",
      "contact": "Контактна информација за логистиката",
      "userAgree": "Се согласувам со {0}",
      "userAgreeLink": "Услови за користење",
      "uspsTrackingInstructions": "Упатства за следење USPS",
      "uspsInstructions1": "Поради промени во политиките на USPS, следењето на USPS сега користи посветена квота. Корисниците што плаќаат можат да додаваат броеви за следење на USPS до границата на нивниот план по циклус на наплата. Квотата автоматски се ресетира.",
      "uspsInstructions2": "Доколку достапните планови сè уште не ги задоволуваат вашите потреби за следење USPS, ве молиме контактирајте го нашиот тим за поддршка на "
  },
  "ms": {
      "help": "Saya belum menerima barang",
      "quotaLimit": "Penjejakan USPS tidak tersedia. Had dicapai",
      "uspsLimitedTips": "Penjejakan USPS terhad kerana perubahan polisi. Naik taraf untuk lebih banyak permintaan penjejakan.",
      "learnMore": "Ketahui Lebih Lanjut",
      "upgradePlan": "Naik taraf sekarang",
      "helpDesc": "Kami sangat menyesal. 17TRACK ialah platform agregasi maklumat logistik global pihak ketiga yang membolehkan anda menyemak status logistik beberapa pakej dengan mudah. Untuk masalah penghantaran pakej, sila hubungi syarikat logistik atau pengusaha.",
      "helpTitle": "Yang dihormati pengguna",
      "website": "Laman web rasmi",
      "noWebsite": "Tiada maklumat laman web rasmi tersedia. Dicadangkan untuk menghubungi penjual.",
      "contact": "Info kontak logistik",
      "userAgree": "Setuju dengan {0}",
      "userAgreeLink": "Terma Perkhidmatan",
      "uspsTrackingInstructions": "Arahan penjejakan USPS",
      "uspsInstructions1": "Disebabkan oleh perubahan dasar USPS, penjejakan USPS kini menggunakan kuota khusus. Pengguna berbayar boleh menambah nombor penjejakan USPS sehingga had pelan mereka setiap kitaran bil. Kuota ditetapkan semula secara automatik.",
      "uspsInstructions2": "Jika pelan yang tersedia masih tidak memenuhi keperluan penjejakan USPS anda, sila hubungi pasukan sokongan kami di "
  },
  "nl": {
      "help": "Ik heb de goederen niet ontvangen",
      "quotaLimit": "USPS-tracking niet beschikbaar. Limiet bereikt.",
      "uspsLimitedTips": "USPS-tracking is beperkt door beleidswijzigingen. Upgrade voor meer trackingverzoeken.",
      "learnMore": "Meer informatie",
      "upgradePlan": "Nu upgraden",
      "helpDesc": "Wij zijn u zeer erbarmelijk. 17TRACK is een derde-partijplatform voor wereldwijd aggregatie van logistieke informatie, waardoor u de logistieke status van meerdere pakketten gemakkelijk kunt opvragen. Bij problemen met de levering van pakketten neem dan contact op met het logistieke bedrijf of de handelaar.",
      "helpTitle": "Geachte gebruiker",
      "website": "Officiële website",
      "noWebsite": "Geen informatie over de officiële website beschikbaar. Raadpleeg de verkoper.",
      "contact": "Logistiek contactinfo",
      "userAgree": "Akkoord gaan met de {0}",
      "userAgreeLink": "Gebruiksvoorwaarden",
      "uspsTrackingInstructions": "USPS-trackinginstructies",
      "uspsInstructions1": "Vanwege beleidswijzigingen van USPS gebruikt USPS-tracking nu een speciaal quotum. Betalende gebruikers kunnen per factureringscyclus USPS-trackingnummers toevoegen tot hun plangrens. Het quotum wordt automatisch gereset.",
      "uspsInstructions2": "Als de beschikbare abonnementen nog steeds niet voldoen aan uw USPS-trackingbehoeften, neem dan contact op met ons ondersteuningsteam via "
  },
  "no": {
      "help": "Jeg har ikke fått varene",
      "quotaLimit": "USPS-sporing utilgjengelig. Grensen er nådd.",
      "uspsLimitedTips": "USPS-sporing er begrenset på grunn av policyendringer. Oppgrader for flere sporingsforespørsler.",
      "learnMore": "Lær mer",
      "upgradePlan": "Oppgrader nå",
      "helpDesc": "Vi er svært lei. 17TRACK er en tredjepartsplatform for global aggregering av logistisk informasjon som lar deg enkelt sjekke logistikstatusen til flere pakker. Ved leveringsproblemer med pakker, kontakt logistikselskapet eller forhandleren.",
      "helpTitle": "Kjære bruker",
      "website": "Offisiell nettside",
      "noWebsite": "Ingen informasjon om den offisielle nettsiden tilgjengelig. Anbefales å kontakte selgeren.",
      "contact": "Logistikk kontaktinfo",
      "userAgree": "Godta {0}",
      "userAgreeLink": "Bruksvilkår",
      "uspsTrackingInstructions": "USPS-sporingsinstruksjoner",
      "uspsInstructions1": "På grunn av policyendringer hos USPS bruker USPS-sporing nå en dedikert kvote. Betalende brukere kan legge til USPS-sporingsnumre opp til plankravet per faktureringssyklus. Kvoten tilbakestilles automatisk.",
      "uspsInstructions2": "Hvis tilgjengelige planer fortsatt ikke dekker dine USPS-sporingsbehov, vennligst kontakt supportteamet vårt på "
  },
  "pl": {
      "help": "Nie otrzymałem towaru",
      "quotaLimit": "Śledzenie USPS niedostępne. Osiągnięto limit.",
      "uspsLimitedTips": "Śledzenie USPS jest ograniczone z powodu zmian zasad. Ulepsz, aby uzyskać więcej żądań śledzenia.",
      "learnMore": "Dowiedz się więcej",
      "upgradePlan": "Uaktualnij teraz",
      "helpDesc": "Jesteśmy bardzo przepraszamy. 17TRACK to trzeciorzędowa globalna platforma agregująca informacje logistyczne, która umożliwia łatwe sprawdzenie statusu logistycznego kilku paczek. W przypadku problemów z dostawą paczek skontaktuj się z firmą logistyczną lub handlowcem.",
      "helpTitle": "Szanowny użytkowniku",
      "website": "Strona internetowa",
      "noWebsite": "Brak dostępnych informacji o oficjalnej stronie internetowej. Zaleca się skontaktowanie się z sprzedawcą.",
      "contact": "Logistyczna info kontaktowa",
      "userAgree": "Zgadzam się na {0}",
      "userAgreeLink": "Warunki korzystania z usługi",
      "uspsTrackingInstructions": "Instrukcje śledzenia USPS",
      "uspsInstructions1": "Ze względu na zmiany polityki USPS, śledzenie USPS korzysta teraz z dedykowanego limitu. Płatni użytkownicy mogą dodawać numery śledzenia USPS do limitu swojego planu na cykl rozliczeniowy. Limit jest automatycznie resetowany.",
      "uspsInstructions2": "Jeśli dostępne plany nadal nie spełniają Twoich potrzeb związanych ze śledzeniem USPS, skontaktuj się z naszym zespołem pomocy technicznej pod adresem "
  },
  "pt-br": {
      "help": "Não recebi a mercadoria",
      "quotaLimit": "Rastreamento USPS indisponível. Limite atingido.",
      "uspsLimitedTips": "O rastreamento USPS está limitado devido a mudanças de política. Atualize para obter mais solicitações de rastreamento.",
      "learnMore": "Saber mais",
      "upgradePlan": "Atualizar agora",
      "helpDesc": "Lamentamos muito. 17TRACK é uma plataforma terceirizada de agregação de informações logísticas globais, que permite consultar convenientemente o status logístico de múltiplos pacotes. Para problemas de entrega de pacotes, entre em contato com a empresa logística ou o comerciante.",
      "helpTitle": "Caro usuário",
      "website": "Site oficial",
      "noWebsite": "Nenhuma informação do site oficial disponível. Recomenda-se entrar em contato com o vendedor.",
      "contact": "Info de contato de logística",
      "userAgree": "Aceitar os {0}",
      "userAgreeLink": "Termos de serviço",
      "uspsTrackingInstructions": "Instruções de rastreamento USPS",
      "uspsInstructions1": "Devido a alterações nas políticas dos USPS, o rastreamento USPS agora utiliza uma cota dedicada. Utilizadores pagantes podem adicionar números de rastreamento USPS até ao limite do seu plano por ciclo de faturamento. A cota é reposta automaticamente.",
      "uspsInstructions2": "Se os planos disponíveis ainda não atenderem às suas necessidades de rastreamento USPS, entre em contato com nossa equipe de suporte pelo e-mail "
  },
  "pt": {
      "help": "Não recebi a mercadoria",
      "quotaLimit": "Rastreamento USPS indisponível. Limite atingido.",
      "uspsLimitedTips": "O rastreamento USPS está limitado devido a mudanças de política. Atualize para obter mais solicitações de rastreamento.",
      "learnMore": "Saber mais",
      "upgradePlan": "Atualizar agora",
      "helpDesc": "Lamentamos muito. 17TRACK é uma plataforma terceirizada de agregação de informações logísticas globais, que permite consultar convenientemente o status logístico de múltiplos pacotes. Para problemas de entrega de pacotes, entre em contato com a empresa logística ou o comerciante.",
      "helpTitle": "Caro usuário",
      "website": "Site oficial",
      "noWebsite": "Nenhuma informação do site oficial disponível. Recomenda-se contactar o vendedor.",
      "contact": "Info de contato de logística",
      "userAgree": "Aceitar os {0}",
      "userAgreeLink": "Termos de serviço",
      "uspsTrackingInstructions": "Instruções de rastreamento USPS",
      "uspsInstructions1": "Devido a alterações nas políticas dos USPS, o rastreamento USPS agora utiliza uma cota dedicada. Utilizadores pagantes podem adicionar números de rastreamento USPS até ao limite do seu plano por ciclo de faturamento. A cota é reposta automaticamente.",
      "uspsInstructions2": "Se os planos disponíveis ainda não atenderem às suas necessidades de rastreamento USPS, entre em contato com nossa equipe de suporte pelo e-mail "
  },
  "ro": {
      "help": "Nu am primit produsul",
      "quotaLimit": "Urmărirea USPS nu este disponibilă. Limita a fost atinsă.",
      "uspsLimitedTips": "Urmărirea USPS este limitată din cauza schimbărilor de politică. Actualizează pentru mai multe solicitări de urmărire.",
      "learnMore": "Află mai multe",
      "upgradePlan": "Actualizează acum",
      "helpDesc": "Ne pare foarte rău. 17TRACK este o platformă terță de agregare a informațiilor logistice globale, care vă permite să verificați cu ușurință starea logisticii mai multor colete. Pentru probleme de livrare a coletelor, contactați compania logistică sau comerciantul.",
      "helpTitle": "Drag utilizatorule",
      "website": "Site-ul oficial",
      "noWebsite": "Nu există informații despre site-ul oficial disponibile. Se recomandă să contactați vânzătorul.",
      "contact": "Info de contact al logisticii",
      "userAgree": "Acceptați {0}",
      "userAgreeLink": "Termeni și condiții",
      "uspsTrackingInstructions": "Instrucțiuni de urmărire USPS",
      "uspsInstructions1": "Din cauza modificărilor politicilor USPS, urmărirea USPS utilizează acum o cotă dedicată. Utilizatorii plătitori pot adăuga numere de urmărire USPS până la limita planului lor pe ciclu de facturare. Cota este resetată automat.",
      "uspsInstructions2": "Dacă planurile disponibile încă nu îți satisfac nevoile de urmărire USPS, te rugăm să contactezi echipa noastră de asistență la "
  },
  "ru": {
      "help": "Я не получил(а) товар",
      "quotaLimit": "Отслеживание USPS недоступно. Достигнут лимит.",
      "uspsLimitedTips": "Отслеживание USPS ограничено из-за изменений политики. Обновите, чтобы получить больше запросов на отслеживание.",
      "learnMore": "Узнать больше",
      "upgradePlan": "Обновить сейчас",
      "helpDesc": "Мы искренне приносим свои извинения. 17TRACK — третейская глобальная платформа для агрегации логистической информации, которая позволяет удобно проверять логистический статус нескольких посылок. По вопросам доставки посылок свяжитесь с логистической компанией или продавцом.",
      "helpTitle": "Уважаемый пользователь",
      "website": "Официальный сайт",
      "noWebsite": "Информации об официальном сайте нет. Рекомендуется связаться с продавцом.",
      "contact": "Контактная информация логистики",
      "userAgree": "Согласен с {0}",
      "userAgreeLink": "Условия использования",
      "uspsTrackingInstructions": "Инструкции по отслеживанию USPS",
      "uspsInstructions1": "В связи с изменениями политики USPS отслеживание USPS теперь использует выделенную квоту. Платные пользователи могут добавлять номера отслеживания USPS в пределах лимита тарифа за каждый расчетный период. Квота автоматически сбрасывается.",
      "uspsInstructions2": "Если доступные тарифы по-прежнему не удовлетворяют ваши потребности в отслеживании USPS, обратитесь в нашу службу поддержки по адресу "
  },
  "sk": {
      "help": "Nedostal som tovar",
      "quotaLimit": "Sledovanie USPS nie je k dispozícii. Dosiahnutý limit.",
      "uspsLimitedTips": "Sledovanie USPS je obmedzené kvôli zmenám politiky. Aktualizujte pre viac požiadaviek na sledovanie.",
      "learnMore": "Zistite viac",
      "upgradePlan": "Aktualizovať teraz",
      "helpDesc": "Veľmi sa omlouvame. 17TRACK je tretia strana globálna platforma na agregáciu logistických informácií, ktorá vám umožňuje ľahko skontrolovať logistický stav viacerých balíčkov. Pri problémoch s dodacími službami balíčkov kontaktujte logistickú spoločnosť alebo obchodníka.",
      "helpTitle": "Ctitelý užívateľ",
      "website": "Oficiálna webstránka",
      "noWebsite": "Žiadne informácie o oficiálnej webovej stránke nie sú k dispozícii. Odporúča sa kontaktovať predajcu.",
      "contact": "Logistická kontaktná info",
      "userAgree": "Súhlasím s {0}",
      "userAgreeLink": "Podmienky služby",
      "uspsTrackingInstructions": "Pokyny na sledovanie USPS",
      "uspsInstructions1": "Kvôli zmenám politiky USPS, sledovanie USPS teraz používa vyhradenú kvótu. Platiaci používatelia môžu pridať sledovacie čísla USPS až do limitu svojho plánu za fakturačný cyklus. Kvóta sa automaticky resetuje.",
      "uspsInstructions2": "Ak dostupné plány stále nespĺňajú vaše potreby sledovania USPS, kontaktujte náš tím podpory na adrese "
  },
  "sl": {
      "help": "Nisem prejel(a) blago",
      "quotaLimit": "Sledenje USPS ni na voljo. Dosežena je bila omejitev.",
      "uspsLimitedTips": "Sledenje USPS je omejeno zaradi sprememb pravilnika. Nadgradite za več zahtev za sledenje.",
      "learnMore": "Več informacij",
      "upgradePlan": "Nadgradi zdaj",
      "helpDesc": "Zelo se opravičujemo. 17TRACK je tretja stran globalna platforma za agregacijo logističnih informacij, ki omogoča enostavno preverjanje logističnega stanja več paketov. Pri problemih z dostavo paketov kontaktirajte logistično podjetje ali trgovca.",
      "helpTitle": "Spoštovani uporabnik",
      "website": "Zasebna spletna stran",
      "noWebsite": "Ni na voljo informacij o uradni spletni strani. Priporočamo, da se povežete z prodajalcem.",
      "contact": "Logistična kontaktna info",
      "userAgree": "Strinjam se z {0}",
      "userAgreeLink": "Pogoji uporabe",
      "uspsTrackingInstructions": "Navodila za sledenje USPS",
      "uspsInstructions1": "Zaradi sprememb pravilnikov USPS, sledenje USPS zdaj uporablja namensko kvoto. Plačljivi uporabniki lahko dodajajo številke za sledenje USPS do meje svojega načrta na obračunski cikel. Kvota se samodejno ponastavi.",
      "uspsInstructions2": "Če razpoložljivi paketi še vedno ne izpolnjujejo vaših potreb po sledenju USPS, se obrnite na našo ekipo za podporo na "
  },
  "sq": {
      "help": "Nuk kam marrë mallin",
      "quotaLimit": "Gjurmimi i USPS nuk është i disponueshëm. Limiti është arritur.",
      "uspsLimitedTips": "Gjurmimi i USPS është i kufizuar për shkak të ndryshimeve të politikës. Përmirëso për më shumë kërkesa gjurmimi.",
      "learnMore": "Mëso më shumë",
      "upgradePlan": "Përmirëso tani",
      "helpDesc": "Ne jemi shumë të ndjeshëm. 17TRACK është një platformë e tretë për agregimin e informacioneve logjistike globale, e cila ju lejon të kontrolloni me lehtësi statusin logjistik të shumë paketave. Për probleme me dorëzimin e paketave, kontaktoni kompani logjistike ose tregtarin.",
      "helpTitle": "Zëvendësues i nderuar",
      "website": "Faqja zyrtare",
      "noWebsite": "Nuk ka informacione për faqen zyrtare të disponueshme. Rekomandohet të kontaktohet me shitësi.",
      "contact": "Info kontakti i logjistikës",
      "userAgree": "Pranoj {0}",
      "userAgreeLink": "Kushtet e shërbimit",
      "uspsTrackingInstructions": "Udhëzime për gjurmimin USPS",
      "uspsInstructions1": "Për shkak të ndryshimeve të politikave të USPS, gjurmimi i USPS tani përdor një kuotë të dedikuar. Përdoruesit me pagesë mund të shtojnë numra gjurmimi të USPS deri në kufirin e planit të tyre për cikël faturimi. Kuota rivendoset automatikisht.",
      "uspsInstructions2": "Nëse planet e disponueshme ende nuk i plotësojnë nevojat tuaja për gjurmimin e USPS, ju lutemi kontaktoni ekipin tonë mbështetës në "
  },
  "sr": {
      "help": "Нисам добио(ла) робу",
      "quotaLimit": "Праћење USPS-а није доступно. Достигнуто је ограничење.",
      "uspsLimitedTips": "Praćenje USPS je ograničeno zbog promena politike. Nadogradite za više zahteva za praćenje.",
      "learnMore": "Сазнајте више",
      "upgradePlan": "Nadogradi sada",
      "helpDesc": "Много се извињајемо. 17TRACK је трећа страна глобална платформа за агрегацију логистичких информација, која омогућава лако проверања логистичког статуса неколико пакета. За проблеме са испоруком пакета, контактирајте логистичку компанију или трговца.",
      "helpTitle": "Poštovani korisniku",
      "website": "Официјални сајт",
      "noWebsite": "Нема информација о званичном сајту. Предлажемо да контактирате Продавца.",
      "contact": "Логистичка контактна информација",
      "userAgree": "Прихватам {0}",
      "userAgreeLink": "Услови коришћења",
      "uspsTrackingInstructions": "Uputstva za praćenje USPS",
      "uspsInstructions1": "Zbog promene politike USPS-a, praćenje USPS-a sada koristi namensku kvotu. Korisnici koji plaćaju mogu dodati brojeve za praćenje USPS-a do granice svog plana po ciklusu naplate. Kvota se automatski resetuje.",
      "uspsInstructions2": "Ukoliko dostupni planovi i dalje ne zadovoljavaju vaše potrebe za praćenjem USPS-a, kontaktirajte naš tim za podršku na "
  },
  "sv": {
      "help": "Jag har inte fått varorna",
      "quotaLimit": "USPS-spårning är inte tillgänglig. Gränsen är nådd.",
      "uspsLimitedTips": "USPS-spårning är begränsad på grund av policyändringar. Uppgradera för fler spårningsförfrågningar.",
      "learnMore": "Läs mer",
      "upgradePlan": "Uppgradera nu",
      "helpDesc": "Vi är ytterst ledsna. 17TRACK är en tredjepartsplattform för global aggregering av logistisk information, som gör att du enkelt kan kontrollera logistiken för flera paket. För leveransproblem med paket, kontakta logistiksföretaget eller handlaren.",
      "helpTitle": "Kära användare",
      "website": "Officiell webbplats",
      "noWebsite": "Ingen information om den officiella webbplatsen tillgänglig. Rekommenderas att kontakta säljaren.",
      "contact": "Logistik kontaktinfo",
      "userAgree": "Godkänn {0}",
      "userAgreeLink": "Användarvillkor",
      "uspsTrackingInstructions": "USPS-spårningsinstruktioner",
      "uspsInstructions1": "På grund av policyändringar från USPS använder USPS-spårning nu en dedikerad kvot. Betalande användare kan lägga till USPS-spårningsnummer upp till sitt plangräns per faktureringscykel. Kvoten återställs automatiskt.",
      "uspsInstructions2": "Om de tillgängliga planerna fortfarande inte uppfyller dina USPS-spårningsbehov, vänligen kontakta vårt supportteam på "
  },
  "th": {
      "help": "ฉันไม่ได้รับสินค้า",
      "quotaLimit": "ไม่สามารถติดตามพัสดุของ USPS ได้ เนื่องจากถึงขีดจำกัดแล้ว",
      "uspsLimitedTips": "การติดตาม USPS ถูกจำกัดเนื่องจากการเปลี่ยนนโยบาย อัปเกรดเพื่อรับคำขอติดตามเพิ่มเติม",
      "learnMore": "เรียนรู้เพิ่มเติม",
      "upgradePlan": "อัปเกรดตอนนี้",
      "helpDesc": "ขอโทษมากค่ะ/ครับ. 17TRACK เป็นแพลตฟอร์มรวบรวมข้อมูลโลจิสติกส์โลกwide จากบุคคลที่สาม ที่ช่วยให้คุณตรวจสอบสถานะโลจิสติกส์ของพัสดุหลายรายการได้สะดวก สำหรับปัญหาเกี่ยวกับการส่งมอบพัสดุ ขอแนะนำให้ติดต่อ บริษัท โลจิสติกส์หรือผู้ค้า",
      "helpTitle": "คุณผู้ใช้ที่เคารพ",
      "website": "เว็บไซต์ الرسمي",
      "noWebsite": "ไม่มีข้อมูลเว็บไซต์ทางการพร้อมใช้งาน ขอแนะนำให้ติดต่อผู้ขาย",
      "contact": "ข้อมูลติดต่อ บริษัท логисติก",
      "userAgree": "ยอมรับ{0}",
      "userAgreeLink": "ข้อกำหนดการให้บริการ",
      "uspsTrackingInstructions": "คำแนะนำการติดตาม USPS",
      "uspsInstructions1": "เนื่องจากการเปลี่ยนแปลงนโยบายของ USPS การติดตามพัสดุ USPS ขณะนี้ใช้โควต้าเฉพาะ ผู้ใช้ที่ชำระเงินสามารถเพิ่มหมายเลขติดตาม USPS ได้จนถึงขีดจำกัดแผนต่อรอบการเรียกเก็บเงิน โควต้าจะถูกรีเซ็ตโดยอัตโนมัติ",
      "uspsInstructions2": "หากแผนที่มีอยู่ยังไม่ตรงกับความต้องการติดตาม USPS ของคุณ โปรดติดต่อทีมสนับสนุนของเราที่ "
  },
  "tr": {
      "help": "Ürünü almadım",
      "quotaLimit": "USPS takip bilgileri mevcut değil. Limit aşıldı.",
      "uspsLimitedTips": "USPS takibi politika değişiklikleri nedeniyle sınırlıdır. Daha fazla takip isteği için yükseltin.",
      "learnMore": "Daha fazla bilgi edin",
      "upgradePlan": "Şimdi yükselt",
      "helpDesc": "Çok üzgünüz. 17TRACK, global bir üçüncü parti lojistik bilgi toplama platformudur ve size birden fazla paketin lojistik durumunu kolayca kontrol etme imkanı tanır. Paket teslimat sorunları için lojistik şirketi veya satıcı ile iletişime geçiniz.",
      "helpTitle": "Sayın kullanıcı",
      "website": "Resmi web sitesi",
      "noWebsite": "Resmi web sitesi bilgisi yok. Satıcı ile iletişime geçmeniz önerilir.",
      "contact": "Lojistik iletişim info",
      "userAgree": "{0}'yi kabul et",
      "userAgreeLink": "Hizmet Şartları",
      "uspsTrackingInstructions": "USPS takip talimatları",
      "uspsInstructions1": "USPS politika değişiklikleri nedeniyle USPS takibi artık özel bir kota kullanmaktadır. Ücretli kullanıcılar, fatura döngüsü başına plan limitleri dahilinde USPS takip numarası ekleyebilir. Kota otomatik olarak sıfırlanır.",
      "uspsInstructions2": "Mevcut planlar USPS takip ihtiyaçlarınızı hâlâ karşılamıyorsa, lütfen destek ekibimizle  adresinden iletişime geçin."
  },
  "uk": {
      "help": "Я не отримав(ла) товар",
      "quotaLimit": "Відстеження USPS недоступне. Досягнуто ліміту.",
      "uspsLimitedTips": "Відстеження USPS обмежене через зміни політики. Оновіть, щоб отримати більше запитів на відстеження.",
      "learnMore": "Дізнатися більше",
      "upgradePlan": "Оновити зараз",
      "helpDesc": "Ми дуже вибачаємося. 17TRACK — третій-сторонна глобальна платформа для агрегації логістичної інформації, яка дозволяє зручно перевірити логістичний статус кількох посилок. За питаннями доставки посилок зв'яжіться з логістичною компанією або продавцем.",
      "helpTitle": "Dear user",
      "website": "Офіційний сайт",
      "noWebsite": "Інформації про офіційний сайт немає. Рекомендується зв’язатися з продавцем.",
      "contact": "Контактна інформація логістики",
      "userAgree": "Погоджуюся з {0}",
      "userAgreeLink": "Умови використання",
      "uspsTrackingInstructions": "Інструкції з відстеження USPS",
      "uspsInstructions1": "Через зміни політики USPS, відстеження USPS тепер використовує виділену квоту. Платні користувачі можуть додавати номери відстеження USPS відповідно до ліміту свого тарифу за кожний платіжний цикл. Квота автоматично скидається.",
      "uspsInstructions2": "Якщо наявні тарифи все ще не задовольняють ваші потреби у відстеженні USPS, зв’яжіться з нашою службою підтримки за адресою "
  },
  "vi": {
      "help": "Tôi chưa nhận được hàng hóa",
      "quotaLimit": "Dịch vụ theo dõi bưu kiện USPS không khả dụng. Đã đạt giới hạn.",
      "uspsLimitedTips": "Theo dõi USPS bị giới hạn do thay đổi chính sách. Nâng cấp để có thêm yêu cầu theo dõi.",
      "learnMore": "Tìm hiểu thêm",
      "upgradePlan": "Nâng cấp ngay",
      "helpDesc": "Rất tiếc. 17TRACK là nền tảng tổng hợp thông tin logistics toàn cầu của bên thứ ba, cho phép bạn tiện lợi kiểm tra tình trạng logistics của nhiều gói hàng. Với vấn đề giao hàng gói hàng, vui lòng liên hệ với công ty logistics hoặc doanh nghiệp.",
      "helpTitle": "Kính gửi người dùng",
      "website": "Trang web chính thức",
      "noWebsite": "Không có thông tin trang web chính thức khả dụng. Khuyến nghị liên hệ với người bán.",
      "contact": "Info liên hệ logistics",
      "userAgree": "Đồng ý với {0}",
      "userAgreeLink": "Điều khoản dịch vụ",
      "uspsTrackingInstructions": "Hướng dẫn theo dõi USPS",
      "uspsInstructions1": "Do những thay đổi chính sách của USPS, dịch vụ theo dõi USPS hiện sử dụng hạn ngạch dành riêng. Người dùng trả phí có thể thêm mã theo dõi USPS lên đến giới hạn gói dịch vụ mỗi chu kỳ thanh toán. Hạn ngạch được đặt lại tự động.",
      "uspsInstructions2": "Nếu các gói hiện có vẫn không đáp ứng nhu cầu theo dõi USPS của bạn, vui lòng liên hệ với nhóm hỗ trợ của chúng tôi qua địa chỉ "
  },
  "zh-cn": {
      "help": "我没收到货",
      "quotaLimit": "USPS追踪暂不可用，次数已达上限",
      "uspsLimitedTips": "由于政策调整，USPS 查询受到限制。升级以获取更多查询权限。",
      "learnMore": "了解更多",
      "upgradePlan": "立即升级",
      "helpDesc": "万分抱歉，17TRACK 是全球物流信息第三方聚合平台，可让您便捷查询多个包裹的物流状态。包裹的配送问题请联系物流公司或商家。",
      "helpTitle": "尊敬的用户",
      "website": "官网",
      "noWebsite": "暂无官网信息，建议联系卖家",
      "contact": "物流公司联系方式",
      "userAgree": "同意17TRACK{0}",
      "userAgreeLink": "服务条款",
      "uspsTrackingInstructions": "USPS 查询说明",
      "uspsInstructions1": "受 USPS 政策调整影响，USPS 查询现采用专用额度制。付费用户每个结算周期内可按套餐上限添加 USPS 查询号，额度自动重置。",
      "uspsInstructions2": "如果现有套餐仍无法满足您的 USPS 查询需求，请联系我们的客服团队："
  },
  "zh-hk": {
      "help": "我沒收到貨",
      "quotaLimit": "USPS追蹤暫不可用，次數已達上限",
      "uspsLimitedTips": "由於政策調整，USPS 查詢受到限制。升級以獲取更多查詢權限。",
      "learnMore": "了解更多",
      "upgradePlan": "立即升級",
      "helpDesc": "萬分抱歉，17TRACK 是全球物流資訊第三方聚合平台，可讓您便捷查詢多個包裹的物流狀態。包裹的配送問題請聯繫物流公司或商家。",
      "helpTitle": "尊敬的用戶",
      "website": "官網",
      "noWebsite": "暫無官網資訊，建議聯繫賣家",
      "contact": "物流公司聯繫方式",
      "userAgree": "同意17TRACK{0}",
      "userAgreeLink": "服務條款",
      "uspsTrackingInstructions": "USPS 查詢說明",
      "uspsInstructions1": "受 USPS 政策調整影響，USPS 查詢現採用專用額度制。付費用戶每個結算週期內可按套餐上限添加 USPS 查詢號，額度自動重置。",
      "uspsInstructions2": "如果現有套餐仍無法滿足您的 USPS 查詢需求，請聯繫我們的客服團隊："
  }
}
export default text